import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(VForm, { ref: "form", staticClass: "form mt-2" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c(VCombobox, {
              attrs: {
                multiple: "",
                dense: "",
                outlined: "",
                label: _vm.$t("attributes.label.users"),
                placeholder: _vm.$t("attributes.placeholder.input_user"),
                rules: _vm.rules.users,
                chips: "",
                "append-icon": "",
                loading: _vm.isLoadingEmail,
                readonly: _vm.isLoadingEmail,
                "error-messages": _vm.errors,
              },
              scopedSlots: _vm._u([
                {
                  key: "selection",
                  fn: function (ref) {
                    var item = ref.item
                    var attrs = ref.attrs
                    var selected = ref.selected
                    var disabled = ref.disabled
                    var parent = ref.parent
                    return [
                      _c(
                        VChip,
                        _vm._b(
                          {
                            key: JSON.stringify(item),
                            attrs: {
                              "input-value": selected,
                              disabled: disabled,
                              close: "",
                              dark: "",
                            },
                            on: {
                              "click:close": function ($event) {
                                return parent.selectItem(item)
                              },
                            },
                          },
                          "v-chip",
                          attrs,
                          false
                        ),
                        [_vm._v(" " + _vm._s(item) + " ")]
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.newUsers,
                callback: function ($$v) {
                  _vm.newUsers = $$v
                },
                expression: "newUsers",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-12 text-right" },
          [
            _c(
              VBtn,
              {
                attrs: { color: "primary", type: "submit" },
                on: { click: _vm.onSubmit },
              },
              [_vm._v(" " + _vm._s(_vm.$t("common.add")) + " ")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "col-md-12 mt-2" },
        [
          _c(VDataTable, {
            key: _vm.keyTable,
            staticClass: "table-inca elevation-2",
            attrs: {
              items: _vm.usersList,
              headers: _vm.headers,
              dense: "",
              "hide-default-footer": "",
              "items-per-page": _vm.pagination.limit,
              page: _vm.pagination.current,
            },
            on: {
              pagination: function ($event) {
                _vm.pagination.total = $event.itemsLength
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.pagination, "current", $event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "item.actions",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _vm.isUserOwner(item)
                      ? _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "btn-icon-inca",
                                              attrs: { icon: "", small: "" },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [_c(VIcon, [_vm._v("mdi-crown")])],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("frases.attrs_sandbox_owner"))
                              ),
                            ]),
                          ]
                        )
                      : _vm.isServiceAccount(item)
                      ? _c("v-div")
                      : _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "btn-icon-inca",
                                              attrs: { icon: "", small: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onRevokeUser(item)
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(VIcon, [
                                            _vm._v("mdi-minus-circle-outline"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("frases.delete_user"))),
                            ]),
                          ]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }